// extracted by mini-css-extract-plugin
module.exports = {"toggle":"inputs_toggle__3Qb-C"};